import { create } from 'zustand';

import { GlobalModalProps } from '../Member/components/GlobalModal';
import { createSelectors } from '../utils/zustand/createSelectors';

interface GlobalModalStore {
  /** 글로벌 모달 Props */
  globalModal: GlobalModalProps | null;

  /** 글로벌 모달 설정 */
  setGlobalModal: (globalModal: GlobalModalProps | null) => void;
}

/**
 * 글로벌 모달 상태를 관리하는 Zustand store
 */
const useGlobalModalStoreBase = create<GlobalModalStore>((set) => ({
  globalModal: null,
  setGlobalModal: (globalModal) => set({ globalModal }),
}));

export const useGlobalModalStore = createSelectors(useGlobalModalStoreBase);
